import axios from 'axios';
import authHeader from './auth-header';

//const API_URL = 'http://localhost:8080/matrix-mlm/api/mlm/montmembbo/';
const API_URL = 'https://www.edibleherbsstores.com/api/mlm/montmembbo/';

class MonthlyMembersBonusService {
  getAll(page, pageSize) {
    return axios.get(API_URL + `monthlymembersbonus/all?page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  get(id) {
    return axios.get(API_URL + `monthlymembersbonus/${id}`, { headers: authHeader() });
  }

  create(monthlyMembersBonus) {
    return axios.post(API_URL + `monthlymembersbonus/cre`, {
      memberId: monthlyMembersBonus.memberId,
      month: monthlyMembersBonus.month,
      year: monthlyMembersBonus.year,
      surname: monthlyMembersBonus.surname,
      firstName: monthlyMembersBonus.firstName,
      middleName: monthlyMembersBonus.middleName,
      nation: monthlyMembersBonus.nation,
      networkId: monthlyMembersBonus.networkId,
      layer: monthlyMembersBonus.layer,
      level: monthlyMembersBonus.level,
      currentPpv: monthlyMembersBonus.currentPpv,
      currentGpv: monthlyMembersBonus.currentGpv,
      accPpv: monthlyMembersBonus.accPpv,
      accGpv: monthlyMembersBonus.accGpv,
      sponsorId: monthlyMembersBonus.sponsorId,
      totalBonus: monthlyMembersBonus.totalBonus,
      activationVerified: monthlyMembersBonus.activationVerified,
      bonusToGive: monthlyMembersBonus.bonusToGive
    }, { headers: authHeader() });
  }

  update(id, monthlyMembersBonus) {
    return axios.put(API_URL + `monthlymembersbonus/${id}/upd`, {
      id: monthlyMembersBonus.id,  
      memberId: monthlyMembersBonus.memberId,
      month: monthlyMembersBonus.month,
      year: monthlyMembersBonus.year,
      surname: monthlyMembersBonus.surname,
      firstName: monthlyMembersBonus.firstName,
      middleName: monthlyMembersBonus.middleName,
      nation: monthlyMembersBonus.nation,
      networkId: monthlyMembersBonus.networkId,
      layer: monthlyMembersBonus.layer,
      level: monthlyMembersBonus.level,
      currentPpv: monthlyMembersBonus.currentPpv,
      currentGpv: monthlyMembersBonus.currentGpv,
      accPpv: monthlyMembersBonus.accPpv,
      accGpv: monthlyMembersBonus.accGpv,
      sponsorId: monthlyMembersBonus.sponsorId,
      totalBonus: monthlyMembersBonus.totalBonus,
      activationVerified: monthlyMembersBonus.activationVerified,
      bonusToGive: monthlyMembersBonus.bonusToGive
    }, { headers: authHeader() });
  }

  delete(id) {
    return axios.delete(API_URL + `del/${id}`, { headers: authHeader() });
  }

  deleteAll() {
    return axios.delete(API_URL + `delall`, { headers: authHeader() });
  }

  getMonthlyMembersBonusByMemberId(memberId) {
    return axios.get(API_URL + `monthlymembersbonus/${memberId}/member`, { headers: authHeader() });
  }

  getMonthlyMembersBonusByMemberIdMonthAndYear(memberId, month, year, page, pageSize) {
    //return axios.get(API_URL + `monthlymembersbonus/${memberId}/${month}/${year}/${page}/${pageSize}/membermonthandyear`, { headers: authHeader() });
    return axios.get(API_URL + `monthlymembersbonus/membermonthandyear?memberId=${memberId}&month=${month}&year=${year}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getMonthlyMembersBonusByMonthAndYear(month, year, page, pageSize) {
    //return axios.get(API_URL + `monthlymembersbonus/${month}/${year}/${page}/${pageSize}/monthandyear`, { headers: authHeader() });
    return axios.get(API_URL + `monthlymembersbonus/monthandyear?month=${month}&year=${year}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getMonthlyMembersBonusByMonthYearAndMembersStatus(month, year, membersStatus, page, pageSize) {
    //return axios.get(API_URL + `monthlymembersbonus/${month}/${year}/${membersStatus}/${page}/${pageSize}/monthyearandmembersstatus`, { headers: authHeader() });
    return axios.get(API_URL + `monthlymembersbonus/monthyearandmembersstatus?month=${month}&year=${year}&membersStatus=${membersStatus}&page=${page}&size=${pageSize}`, { headers: authHeader() });
  }

  getTotalMonthlyMembersBonusByMemberIdMonthAndYear(memberId, month, year) {
    return axios.get(API_URL + `monthlymembersbonus/${memberId}/${month}/${year}/totalmmbbymembermonthandyear`, { headers: authHeader() });
  }

  getTotalMonthlyMembersBonusByMonthAndYear(month, year) {
    return axios.get(API_URL + `monthlymembersbonus/${month}/${year}/totalmmbbymonthandyear`, { headers: authHeader() });
  }

  getTotalMonthlyMembersBonusByMonthYearAndMembersStatus(month, year, membersStatus) {
    return axios.get(API_URL + `monthlymembersbonus/${month}/${year}/${membersStatus}/totalmmbbymonthyearandmembersstatus`, { headers: authHeader() });
  }

  getMonthlyMembersBonusByMemberIdMonthAndYearExportToExcel(memberId, month, year, page, pageSize) {
    return axios.get(API_URL + `monthlymembersbonus/membermonthandyearexporttoexcel?memberId=${memberId}&month=${month}&year=${year}&page=${page}&size=${pageSize}`, { headers: authHeader() }, {responseType: 'blob'});
  }
  
}

export default new MonthlyMembersBonusService();